import React from "react";
import { Button, CircularProgress } from "@mui/material";
import { useAppSelector } from "../../../../../app/hooks";
import { useCalculateReimbursementMutation } from "../../../../../services/accountService/account-api";

function CalculateReimbursementBtn() {
    const account = useAppSelector((e) => e.account.account);
    const [calculateReimbursement, { isLoading }] = useCalculateReimbursementMutation();

    const handleClick = async () => {
        if (account?.id) {
            await calculateReimbursement(account.id);
        }
    };

    return (
        <Button 
            variant="contained" 
            color="primary" 
            onClick={handleClick}
            disabled={isLoading || !account?.id}
            startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : null}
        >
            {isLoading ? "Calculating..." : "Calculate Reimbursement"}
        </Button>
    );
}

export { CalculateReimbursementBtn };
